import { httpClient } from '@/utils/http-client';
class TemplatesService {
    httpClient;
    constructor() {
        this.httpClient = httpClient;
    }
    formatObject(template) {
        let isFavorite = false;
        if (template.userTemplates && template.userTemplates.length >= 1) {
            isFavorite = true;
        }
        return {
            id: template.id,
            title: template.title,
            preview: template.preview?.publicUrl,
            content: template?.content,
            width: template.width,
            height: template.height,
            shape: template.shape,
            tags: template.tags,
            isFeatured: template.isFeatured,
            isFavorite: isFavorite,
            isFree: template.isFree,
            devalueLevel: template.devalueLevel
        };
    }
    async getTemplate(id) {
        const response = await this.httpClient.get('/templates/' + id);
        return this.formatObject(response.data);
    }
    async getTemplatesList(page, limit, shape, tags, favorites) {
        const response = await this.httpClient.get('/templates', {
            params: {
                page: page,
                limit: limit,
                shape: shape,
                tags: tags,
                favorites: favorites
            }
        });
        return response.data.items.map((template) => {
            return this.formatObject(template);
        });
    }
    async deleteTemplate(id) {
        const response = await this.httpClient.delete('/templates/' + id);
        if (response.data)
            return true;
        return false;
    }
    async featureTemplate(id, feature) {
        const response = await this.httpClient.patch('/templates/' + id, {
            isFeatured: feature
        });
        if (response.data)
            return true;
        return false;
    }
    async setFavorite(id) {
        try {
            const response = await this.httpClient.post('/user-templates', {
                templateId: id
            });
            if (response.data)
                return true;
            return false;
        }
        catch (error) {
            return false;
        }
    }
    async setDevalue(id, value) {
        try {
            const response = await this.httpClient.patch(`/templates/devalue/${id}`, {
                devalueLevel: value
            });
            return response.data.result === true;
        }
        catch (error) {
            return false;
        }
    }
}
export default TemplatesService;
